import React, { useEffect, useRef } from 'react';
import { formatNumber2 } from '../../../utils/currencyFormat';
const c3 = window.c3;

export const ChartSectionLoiNhuan = ({ data, loading }) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (!chartRef.current) return;
        if (loading || !data || data.length === 0) {
            if (chartInstance.current) {
                try { chartInstance.current.destroy(); } catch (e) { console.error(e); }
                chartInstance.current = null;
            }
            return;
        }
        const xData = ['x', ...data.map(item => item.ThoiGianHienThi)];
        const yData = ['Lợi nhuận', ...data.map(item => item.LoiNhuanRong)];

        chartInstance.current = c3.generate({
            bindto: chartRef.current,
            data: {
                x: 'x',
                columns: [xData, yData],
                type: 'line',
            },
            axis: {
                x: { 
                    type: 'category',
                    tick: {
                        rotate: 45, 
                        multiline: false
                    }
                },
                y: {
                    label: { text: 'Số tiền (VNĐ)', position: 'outer-middle' },
                    tick: {
                        format: function (d) {
                            return formatNumber2(d);
                        }
                    }
                }
            },
            grid: {
                y: { show: true }
            },
            point: {
                show: true,
                r: 4 
            },
            tooltip: {
                format: {
                    value: function (value) {
                        return formatNumber2(value);
                    }
                }
            },
            color: { pattern: ['#1f77b4'] }
        });

        return () => {
            if (chartInstance.current) {
                 try { chartInstance.current.destroy(); } catch (e) {}
                chartInstance.current = null;
            }
        };
    }, [data, loading]);

    return (
        <div style={{ height: 400, display: 'flex', flexDirection: 'column' }} className="p-1">
            <h4 className="interest-rate-title" style={{ flexShrink: 0 }}>
                Biểu đồ lợi nhuận thực tế</h4>
            <div style={{ flex: 1, position: 'relative', width: '100%' }}>
                {loading && (
                    <div className="d-flex justify-content-center align-items-center" 
                        style={{
                            position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)', zIndex: 2 
                        }}
                    >
                        <div className="spinner-border text-primary" role="status"></div>
                    </div>
                )}
                <div 
                    ref={chartRef} 
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: loading ? 0.5 : 1, zIndex: 1 }} 
                />
            </div>
        </div>
    );
};